// src/pages/Services.js


import React from 'react';
import Hero from '../components/Hero';
import { fetchPageContent } from '../utils/api';
import useFetch from '../hooks/useFetch';
import { Helmet } from 'react-helmet-async';
import InteriorHeroSkeleton from '../components/InteriorHeroSkeleton';
import Footer from '../components/Footer';
import FooterHero from '../components/FooterHero';
import Testimonials from '../components/Testimonials';
import { NavLink } from 'react-router-dom';
import ProjectsSlider from '../components/ProjectsSlider';

const Services = () => {
  const { data: heroContent, data: interiorPageContent, loading } = useFetch(() => fetchPageContent('services'), 'services');

  return (
    <div>
      {loading ? (
        // Render HeroSkeleton component when loading
        <InteriorHeroSkeleton />
      ) : (
        (
          <>
            <Helmet>
              <title>Services Page</title>
              <meta name="description" content="This is the home page of the website." />
              <meta name="viewport" content="width=device-width, initial-scale=1.0" />
              <link rel="canonical" href="http://yourwebsite.com/home" />

              <link rel="preconnect" href="https://fonts.googleapis.com" />
              <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
              <link href="https://fonts.googleapis.com/css2?family=Maven+Pro:wght@400..900&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap" rel="stylesheet" />
              <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css" integrity="sha384-QWTKZyjpPEjISv5WaRU9OFeRpok6YctnYmDr5pNlyT2bRjXh0JMhjY6hW+ALEwIH" crossorigin="anonymous"></link>
              <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/js/bootstrap.bundle.min.js" integrity="sha384-YvpcrYf0tY3lHB60NNkmXc5s9fDVZLESaAA55NDzOxhy9GkcIdslK1eN7N6jIeHz" crossorigin="anonymous"></script>
            </Helmet>
            {loading ? (
              <p>Loading...</p>
            ) : (
              heroContent && <Hero className="interior-hero" content={heroContent.hero} featuredMedia={heroContent.featuredMedia} />
            )}
            {/* Other WhoWeAre Page Content */}
            {interiorPageContent?.interiorPageContent && (
              <div className='container'>
                <div className="main-page-content row justify-content-center">
                  {/* <div className='col-lg-8 panel' dangerouslySetInnerHTML={{ __html: interiorPageContent.interiorPageContent }} /> */}
                  <div className='col-12'>
                    <div className="interior-page-section-contained small-section">
                      <div className="section-background"
                        style={{ backgroundImage: `url(https://headless.lizotteconstruction.com/wp-content/uploads/2024/11/20230526_131049-scaled.webp)` }}
                      />
                      <div className="container">
                        <h2>Gravel</h2>
                        <p>High-quality gravel solutions for all projects.</p>
                        <p><NavLink className="button" to="/services/gravel">More About Our Gravel Solutions</NavLink></p>
                      </div>
                    </div>
                    <div className="interior-page-section-contained small-section">
                      <div className="section-background"
                        style={{ backgroundImage: `url(https://headless.lizotteconstruction.com/wp-content/uploads/2024/11/20230619_122930-scaled.webp)` }}
                      />
                      <div className="container">
                        <h2>Septic Systems</h2>
                        <p>Expert septic system installation and repair.</p>
                        <p><NavLink className="button" to="/services/septic-systems">More About Septic Systems</NavLink></p>
                      </div>
                    </div>
                    <div className="interior-page-section-contained small-section">
                      <div className="section-background"
                        style={{ backgroundImage: `url(https://headless.lizotteconstruction.com/wp-content/uploads/2024/11/20220806_130224-2-scaled.webp)` }}
                      />
                      <div className="container">
                        <h2>House Lots</h2>
                        <p>Comprehensive site preparation for homes.</p>
                        <p><NavLink className="button" to="/services/house-lots">More About House Lots</NavLink></p>
                      </div>
                    </div>
                    <div className="interior-page-section-contained small-section">
                      <div className="section-background"
                        style={{ backgroundImage: `url(https://headless.lizotteconstruction.com//wp-content/uploads/2024/11/IMG_3180-edited-scaled.webp)` }}
                      />
                      <div className="container">
                        <h2>Maintenance And More</h2>
                        <p>Driveway maintenance and related services.</p>
                        <p><NavLink className="button" to="/services/house-lots">More About Maintenance and Related Services</NavLink></p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </>
        )
      )}
      <ProjectsSlider />
      <Testimonials />
      <FooterHero />
      <Footer />
    </div>
  );
};

export default Services;
